import { Link } from "react-router-dom";
import { LogOut, User, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const UserMenuButton = ({ user, onLogout }) => {
  const initial = user?.name?.charAt(0)?.toUpperCase() || "U";

  return (
    <div className="flex items-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="h-10 px-1 md:px-2 rounded-full text-white hover:bg-white/10 hover:text-white"
            data-testid="top-user-menu-trigger"
          >
            <div className="flex items-center gap-2">
              <div className="hidden md:block text-right leading-tight">
                <p className="text-sm font-medium text-white truncate max-w-[180px]">
                  {user?.name || "Benutzer"}
                </p>
                <p className="text-xs text-gray-300 truncate max-w-[220px]">
                  {user?.email || ""}
                </p>
              </div>
              <span className="h-9 w-9 rounded-full border border-gray-300 bg-white text-[#212529] inline-flex items-center justify-center">
                {initial}
              </span>
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          {user?.is_site_admin ? (
            <DropdownMenuItem asChild>
              <Link to="/site-admin/email" className="cursor-pointer">
                <Mail className="w-4 h-4 mr-2" />
                Admin-Einstellungen
              </Link>
            </DropdownMenuItem>
          ) : null}
          {user?.is_site_admin ? <DropdownMenuSeparator /> : null}
          <DropdownMenuItem asChild>
            <Link to="/profil" className="cursor-pointer">
              <User className="w-4 h-4 mr-2" />
              Benutzer Einstellungen
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onLogout} className="cursor-pointer text-red-600 focus:text-red-600">
            <LogOut className="w-4 h-4 mr-2" />
            Abmelden
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default UserMenuButton;
